import Link from 'next/link'

const BreadCrumb = ({ props, theme = false }) => {
  const renderBCrumb = () => {
    if (!theme) {
      let calculatedLink = ''
      return props.map((element, i) => {
        calculatedLink += `/${element.slug}`
        return (
          <div className="breadcrumb__element" key={`/c${calculatedLink}`}>
            <Link href={`/c${calculatedLink}`} data-testid="bc-anchor" className="breadcrumb-focus" tabIndex={0} aria-label={calculatedLink}>
                <div>
                  <p role='link' className="breadcrumb__label">{(element.category || element.name)?.toLowerCase()}</p>
                </div>
            </Link>
            {i < props.length - 1 && <div className="breadcrumb__separator"> &gt; </div>}
          </div>
        )
      })
    } else {
      return props.map((element, i) => (
        <div className="breadcrumb__element" key={i}>
          <Link href={i === 0 ? '/' : `/theme/${element.slug}`} data-testid="bc-anchor" className="breadcrumb-focus" tabIndex={0} aria-label={element.slug} {...(i + 1 === props.length && { 'aria-current': 'page' })}>
            <div>
              <h6 role='link' className="breadcrumb__label">{i === 0 ? 'home' : (element.name)?.toLowerCase()}</h6>
            </div>
          </Link>
          {i < props.length - 1 && <div className="breadcrumb__separator"> &gt; </div>}
        </div>
      ))
    }
  }

  return (
    <div className="breadcrumb"> {renderBCrumb()} </div>
  )
}

export default BreadCrumb
